/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgFontStyle = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M4.16 16H2L7.727 2h2.161l1.329 3.248-1.08 2.64-1.33-3.247L6.208 11h2.657l-.819 2H5.388zm9.567-12L8 18h2.16l1.228-3h6.84l1.226 3h2.161L15.888 4zm3.682 9h-5.203l2.602-6.359zM22 20H8v2h14z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgFontStyle as FontStyle };
